import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MappingGeofencedZoneGroupService } from "src/app/services/mapping-geofenced-zone-group.service";
import {
    FormComponent,
    IFormDialogData,
    IOrganizationLevelEntity,
} from "src/app/shared/form/form.component";
import { TextFormField } from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import { MappingGeofencedZoneGroup } from "../../models/mappingGeofencedZoneGroup.model";

export interface IZoneDialogData
    extends IFormDialogData, IOrganizationLevelEntity {
    zoneBoundary: string;
    mappingGroupId: string;
}

@Component({
  standalone: false,
    selector: "app-zone-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class ZoneDialogComponent
    extends FormComponent<MappingGeofencedZoneGroup>
    implements OnInit
{
    constructor(
        public dialogRef: MatDialogRef<ZoneDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IZoneDialogData,
        service: MappingGeofencedZoneGroupService,
        protected injector: Injector,
    ) {
        super(dialogRef, service, data, "Zone", injector);
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        this.getEntity().subscribe(
            (res) => {
                this.entity = res;
                this.initModel();
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    initModel() {
        if (!this.isAdd) return;
        this.entity.zoneBoundary = this.data.zoneBoundary;
        this.entity.organizationLevelId = this.data.organizationLevelId;
        this.entity.mappingGroupId = this.data.mappingGroupId;
    }

    initFields() {
        this.fields = [
            new TextFormField({
                property: nameOf<MappingGeofencedZoneGroup>((x) => x.name),
                name: "Name",
            }),
        ];
    }

    getNewObject(): MappingGeofencedZoneGroup {
        return new MappingGeofencedZoneGroup();
    }

    validate(): boolean {
        return true;
    }
}
